import styled from 'styled-components';
import { BANNER_HEIGHT } from 'view/layout/banner-with-paper-layout-dumb/styled';
import { HEADER_HEIGHT } from 'view/layout/header-dumb/styled';
import * as bp from 'view/styles/breakpoints';
import * as fonts from 'view/styles/fonts';
import { token } from '@atlaskit/tokens';
import { HelpCenterContainer } from './container';

const SEARCH_CONTAINER_PADDING = token('space.600', '48px');

export const SearchContainer = styled(HelpCenterContainer)`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding-top: ${SEARCH_CONTAINER_PADDING};
    padding-bottom: ${SEARCH_CONTAINER_PADDING};
    height: ${BANNER_HEIGHT.unitless - HEADER_HEIGHT}px;
`;

interface HelpCenterTitleProps {
    titleColor?: string;
}

export const HelpCenterTitle = styled.h1<HelpCenterTitleProps>`
    ${fonts.h700};
    margin-bottom: ${token('space.100', '8px')};
    color: ${(props) => (!!props.titleColor ? props.titleColor : props.theme.readableTextColor)};
    text-align: center;

    ${bp.fromXXSmall.css`
        text-align: left;
    `};
`;

export const HelpCenterBucketsContainer = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
`;
